import gql from 'graphql-tag'

export const donwloadFileQuery = gql`
	query downloadFile($input: UploadFile) {
		downloadFile(input: $input) {
			url
			name
		}
	}
`